import { gql, TypedDocumentNode } from "@apollo/client";
import { CRMNote } from "@/types";
import { CRM_NOTE_FIELDS_FRAGMENT } from "@/fragments";
import { PageInfo } from "@/components/Pagination/Pagination";

export interface FacilityNotesQueryResponse {
  facilityNotes: {
    nodes: CRMNote[];
    totalCount: number;
    pageInfo: PageInfo;
    currentPage: number;
  };
}

export const FACILITY_NOTES_QUERY: TypedDocumentNode<FacilityNotesQueryResponse> = gql`
  query FacilityNotesQuery(
    $id: ID!
    $first: Int
    $last: Int
    $after: String
    $before: String
    $input: BackofficeCRMNotesInput
    $orderBy: BackofficeCRMNoteOrderByInput
    $aroundId: ID
  ) {
    facilityNotes(
      id: $id
      first: $first
      last: $last
      after: $after
      before: $before
      input: $input
      orderBy: $orderBy
      aroundId: $aroundId
    ) {
      nodes {
        ...CRMNoteFields
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
      currentPage
    }
  }
  ${CRM_NOTE_FIELDS_FRAGMENT}
`;
